import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { LandingPage } from './landing.page';

import { SearchByServiceComponent } from './search-by-service/search-by-service.component';
import { SearchByKeywordComponent } from './search-by-keyword/search-by-keyword.component';

import { IonicSelectableModule } from 'ionic-selectable';
import { RandomOrderPipe } from '../core/pipes/random-order.pipe';

import { 
  MatDatepickerModule, 
  MatNativeDateModule
} from '@angular/material';

const routes: Routes = [
  {
    path: '',
    component: LandingPage
  }
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    IonicSelectableModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  declarations: [
    LandingPage, 
    SearchByServiceComponent, 
    SearchByKeywordComponent,
    RandomOrderPipe
  ]
})
export class LandingPageModule {}